/* Q&CUTE — Dandelion
   Interaction layer. Progressive: every feature degrades to a working page. */

(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------------
     Scroll reveal — story banners and theme titles only
     --------------------------------------------------------------- */
  function initReveal() {
    var targets = document.querySelectorAll('[data-reveal], [data-reveal-host]');
    if (!targets.length) return;
    if (reduced || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-revealed'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed');
        io.unobserve(entry.target);
      });
    }, { threshold: 0.2, rootMargin: '0px 0px -8% 0px' });
    targets.forEach(function (el) { io.observe(el); });
  }

  /* ---------------------------------------------------------------
     Drifting dandelion seeds across the hero
     --------------------------------------------------------------- */
  function initSeeds() {
    var host = document.querySelector('[data-seeds]');
    if (!host || reduced) return;
    var count = window.innerWidth < 700 ? 7 : 14;
    var svg = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" aria-hidden="true">' +
      '<path d="M12 22V11"/><circle cx="12" cy="8" r="1"/>' +
      '<path d="M12 8 4 3M12 8l8-5M12 8 3 9M12 8l9 1M12 8 6 14M12 8l6 6"/></svg>';
    for (var i = 0; i < count; i++) {
      var s = document.createElement('span');
      s.className = 'seed';
      s.innerHTML = svg;
      s.style.left = (Math.random() * 100) + '%';
      s.style.animationDuration = (16 + Math.random() * 20) + 's';
      s.style.animationDelay = (-Math.random() * 24) + 's';
      s.style.transform = 'scale(' + (0.55 + Math.random() * 0.9) + ')';
      host.appendChild(s);
    }
  }

  /* ---------------------------------------------------------------
     Header state
     --------------------------------------------------------------- */
  function initHeader() {
    var header = document.querySelector('[data-header]');
    if (!header) return;
    var onScroll = function () {
      header.classList.toggle('site-header--scrolled', window.scrollY > 24);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    var toggle = document.querySelector('[data-menu-toggle]');
    var nav = document.querySelector('[data-mobile-nav]');
    if (toggle && nav) {
      toggle.addEventListener('click', function () {
        var open = nav.getAttribute('data-open') === 'true';
        nav.setAttribute('data-open', String(!open));
        toggle.setAttribute('aria-expanded', String(!open));
        document.body.style.overflow = open ? '' : 'hidden';
      });
      nav.querySelectorAll('a').forEach(function (a) {
        a.addEventListener('click', function () {
          nav.setAttribute('data-open', 'false');
          document.body.style.overflow = '';
        });
      });
    }
  }

  /* ---------------------------------------------------------------
     Cart drawer
     --------------------------------------------------------------- */
  var Cart = {
    drawer: null,
    overlay: null,
    open: function () {
      if (!this.drawer) return;
      this.drawer.setAttribute('data-open', 'true');
      this.overlay.setAttribute('data-open', 'true');
      document.body.style.overflow = 'hidden';
      var close = this.drawer.querySelector('[data-cart-close]');
      if (close) close.focus();
    },
    close: function () {
      if (!this.drawer) return;
      this.drawer.setAttribute('data-open', 'false');
      this.overlay.setAttribute('data-open', 'false');
      document.body.style.overflow = '';
    },
    refresh: function () {
      var self = this;
      return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + '?section_id=cart-drawer' : '/?section_id=cart-drawer')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-cart-contents]');
          var current = document.querySelector('[data-cart-contents]');
          if (fresh && current) current.innerHTML = fresh.innerHTML;
          return fetch('/cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            el.textContent = cart.item_count;
          });
          return cart;
        })
        .catch(function () { /* leave the page as-is; the /cart link still works */ });
    }
  };

  function initCart() {
    Cart.drawer = document.querySelector('[data-cart-drawer]');
    Cart.overlay = document.querySelector('[data-overlay]');
    if (!Cart.drawer) return;

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-open]')) { e.preventDefault(); Cart.open(); }
      if (e.target.closest('[data-cart-close]') || e.target.closest('[data-overlay]')) Cart.close();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') Cart.close(); });

    // Quantity steppers and line removal inside the drawer
    document.addEventListener('click', function (e) {
      var step = e.target.closest('[data-qty-step]');
      var remove = e.target.closest('[data-line-remove]');
      if (!step && !remove) return;
      e.preventDefault();

      var key, qty;
      if (remove) {
        key = remove.getAttribute('data-line-remove');
        qty = 0;
      } else {
        var input = step.parentElement.querySelector('input');
        var delta = step.getAttribute('data-qty-step') === 'up' ? 1 : -1;
        qty = Math.max(0, parseInt(input.value, 10) + delta);
        key = input.getAttribute('data-line-key');
        input.value = qty;
      }
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function () { Cart.refresh(); });
    });
  }

  /* ---------------------------------------------------------------
     Product form — add to cart without leaving the page
     --------------------------------------------------------------- */
  function initProductForm() {
    var form = document.querySelector('[data-product-form]');
    if (!form) return;
    form.addEventListener('submit', function (e) {
      if (!window.fetch) return; // fall back to a normal form post
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var original = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding'; }

      fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.status) throw new Error(data.description || data.message);
          return Cart.refresh();
        })
        .then(function () {
          if (btn) { btn.disabled = false; btn.textContent = original; }
          Cart.open();
        })
        .catch(function (err) {
          if (btn) { btn.disabled = false; btn.textContent = original; }
          var note = form.querySelector('[data-form-error]');
          if (note) note.textContent = err.message || 'That size is unavailable. Try another.';
        });
    });
  }

  /* ---------------------------------------------------------------
     Size picker → variant id
     --------------------------------------------------------------- */
  function initVariants() {
    var picker = document.querySelector('[data-size-picker]');
    if (!picker) return;
    var idField = document.querySelector('[data-variant-id]');
    var priceEl = document.querySelector('[data-variant-price]');
    var submit = document.querySelector('[data-product-form] [type="submit"]');

    picker.addEventListener('click', function (e) {
      var btn = e.target.closest('.size-opt');
      if (!btn || btn.getAttribute('data-sold-out') === 'true') return;
      picker.querySelectorAll('.size-opt').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
      btn.setAttribute('aria-pressed', 'true');
      if (idField) idField.value = btn.getAttribute('data-variant');
      if (priceEl && btn.getAttribute('data-price')) priceEl.textContent = btn.getAttribute('data-price');
      if (submit) { submit.disabled = false; submit.textContent = submit.getAttribute('data-label') || 'Add to bag'; }
    });
  }

  /* ---------------------------------------------------------------
     Gallery
     --------------------------------------------------------------- */
  function initGallery() {
    var gallery = document.querySelector('[data-gallery]');
    if (!gallery) return;
    var main = gallery.querySelector('[data-gallery-main]');
    gallery.addEventListener('click', function (e) {
      var thumb = e.target.closest('[data-gallery-thumb]');
      if (!thumb || !main) return;
      gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.setAttribute('aria-current', 'false'); });
      thumb.setAttribute('aria-current', 'true');
      main.src = thumb.getAttribute('data-full');
      main.srcset = thumb.getAttribute('data-srcset') || '';
      main.alt = thumb.querySelector('img') ? thumb.querySelector('img').alt : main.alt;
    });
  }

  /* ---------------------------------------------------------------
     Accordions
     --------------------------------------------------------------- */
  function initAccordions() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.accordion__btn');
      if (!btn) return;
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!open));
      if (panel) panel.setAttribute('data-open', String(!open));
    });
  }

  function boot() {
    initReveal();
    initSeeds();
    initHeader();
    initCart();
    initProductForm();
    initVariants();
    initGallery();
    initAccordions();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
